import type TravelCompanyInput from '@naturehouse/design-system/components/atoms/travel-company-input/TravelCompanyInput';
import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import HouseSearchFilters from '../store/HouseSearchFilters';
import TravelPartyFilter from '../store/TravelPartyFilter';

export default class TravelPartyConnector implements Observer {
    readonly #element: TravelCompanyInput;

    readonly #filter: TravelPartyFilter;

    constructor(element: TravelCompanyInput, filter: TravelPartyFilter) {
        this.#element = element;
        this.#filter = filter;

        this.#element.addEventListener('change', this.#updateFilter.bind(this));
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof TravelPartyFilter)) {
            return;
        }

        this.#element.value = JSON.stringify({
            adults: subject.parameters.adults || '',
            children: subject.parameters.children || '',
            babies: subject.parameters.babies || '',
            pets: subject.parameters.pets || ''
        });
    }

    public static connectToElement(querySelector: string): void {
        const filters = HouseSearchFilters.getInstance();
        const element = document.querySelector(querySelector) as TravelCompanyInput | null;
        const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter | undefined;

        if (!element || !filter) return;

        const connector = new TravelPartyConnector(element, filter);
        filter.attach(connector);
    }

    #updateFilter(): void {
        this.#filter.adults = Number(this.#element.getAttribute('adults') || '0');
        this.#filter.children = Number(this.#element.getAttribute('children') || '0');
        this.#filter.babies = Number(this.#element.getAttribute('babies') || '0');
        this.#filter.pets = Number(this.#element.getAttribute('pets') || '0');
    }
}
